import * as React from "react";
const SvgArrowSeparator = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 18, viewBox: "0 0 8 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0L8 9L0 18V0Z", fill: "#ECECEC" }));
export default SvgArrowSeparator;
